module.exports = __webpack_public_path__ + "static/img/7498_phase_function_Paper_Points.e135ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7498_phase_function_Paper_Points.png
// module id = Ug3D
// module chunks = 0